import { Component, Inject, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';
import { ConfigConstants } from '../../config/config-constants';
import { Router } from '@angular/router';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { DashboardButtonModel } from './dashboard-button.model';
import { DashboardButtonService } from './dashboard-button.service';

@Component({
    selector: 'pace-core-dashboard-button',
    templateUrl: './dashboard-button.component.html',
    styleUrls: ['./dashboard-button.component.scss'],
})
export class DashboardButtonComponent {
    @Input()
    public model: DashboardButtonModel;
    private modalResultSubject: Subject<void>;
    public modalResult$: Observable<void>;
    public constructor(
        private readonly modalService: BsModalService,
        public readonly modalInstance: BsModalRef,
        private readonly router: Router,
        private dashboardButtonService: DashboardButtonService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {
        this.modalResultSubject = new Subject<void>();
        this.modalResult$ = this.modalResultSubject.asObservable();
    }

    public okClick(): void {
        this.modalResultSubject.next();
        this.modalResultSubject.complete();
        this.modalInstance.hide();
    }

    public openDashboard(): void {
        // on click of Dashboard Button redirect the user to New Notification List
        this.dashboardButtonService.redirectToNewNotificationList(true);
        this.router.navigate([ConfigConstants.routeUrlDashboard], {}).catch((err: unknown) => {
            this.log.error(`Could not open Dashboard: ${JSON.stringify(err)}`);
        });
        this.modalInstance.hide();
    }
}
